import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PasswordStrengthBar from "react-password-strength-bar";
import { FormGroup, Label, Input } from 'reactstrap';
import { Validator } from "./Validator";
function BootstrapPasswordInput({ className, value, onChange, disabled, placeholder }) {
    const intl = useIntl();
    const short = intl.formatMessage({ id: "PASSWORD_SHORT" });
    const bad = intl.formatMessage({ id: "PASSWORD_BAD" });
    const okay = intl.formatMessage({ id: "PASSWORD_OKAY" });
    const good = intl.formatMessage({ id: "PASSWORD_GOOD" });
    const perfect = intl.formatMessage({ id: "PASSWORD_PERFECT" });
    const scoreWords = useMemo(() => [short, bad, okay, good, perfect], [short, bad, okay, good, perfect]);
    return React.createElement(React.Fragment, null,
        React.createElement(Input, { className: className, type: "password", value: value || '', onChange: a => onChange(a.currentTarget.value), disabled: disabled, placeholder: placeholder, autoComplete: "new-password" }),
        React.createElement(PasswordStrengthBar, { className: "password-str-bar", password: value || '', scoreWords: scoreWords, shortScoreWord: short }));
}
export default function PasswordInput({ value, onChange, className, disabled, icon, required, placeholder }) {
    const [password2, setPassword2] = useState('');
    const iconElem = icon && React.createElement("i", { className: icon });
    useEffect(function () {
        if (!value) {
            setPassword2('');
        }
    }, [value, setPassword2]);
    return React.createElement(React.Fragment, null,
        React.createElement(FormGroup, { className: className },
            iconElem,
            React.createElement(Label, null,
                React.createElement(FormattedMessage, { id: "PASSWORD" })),
            React.createElement(Validator, { name: "password", type: [required && "required", "securepassword"].filter(a => !!a) },
                React.createElement(BootstrapPasswordInput, { value: value, onChange: onChange, disabled: disabled, placeholder: placeholder }))),
        !!(required || value) && React.createElement(FormGroup, { className: className },
            iconElem,
            React.createElement(Label, null,
                React.createElement(FormattedMessage, { id: "PASSWORD_AGAIN" })),
            React.createElement(Validator, { name: "password2", type: [(required || value) && "required", { password: value || '' }].filter(a => !!a) },
                React.createElement(Input, { type: "password", value: password2 || '', onChange: a => setPassword2(a.currentTarget.value), disabled: disabled, autoComplete: "new-password" }))));
}
